import { useQuery } from '@tanstack/react-query'
import { baseURL } from '@/v2/constants/requests'

export const useFindPatient = query => {
  const term = query?.trim() || ''
  const { data, isLoading, isError } = useQuery({
    queryKey: ['FindPatient', term],
    queryFn: async () => {
      const res = await fetch(
        `${baseURL}/v2/rest/patients?query=${encodeURIComponent(term)}&limit=10`
      )
      if (!res.ok) {
        throw new Error('We could not find a patient')
      }
      return res.json()
    },
    enabled: !!term,
    // Patients get added all day (front desk, online booking), so a search
    // typed again always asks again; the cached result shows meanwhile.
    staleTime: 0,
  })

  return { patients: data, isLoading, isError }
}

export default useFindPatient
